import PenawaranSPK from './PenawaranSPK';

export default PenawaranSPK;
